import { createAsyncThunk } from '@reduxjs/toolkit';
import { pushToTicketNote } from 'services/pod';
import { IPushToCWTicketNotePayload } from 'services/pod/types';

interface IProps {
  psaId: string;
  payload: IPushToCWTicketNotePayload;
}
export const ThunkPushDataToTicket = createAsyncThunk(
  'pod/pushDataToTicket',
  ({ psaId, payload }: IProps) => pushToTicketNote(psaId, payload),
);
